// 统一的认证工具 - 使用 cookie 以便跨子模块共享
const COOKIE_NAME = 'ai_learninghub_auth';
const COOKIE_MAX_AGE = 24 * 60 * 60; // 24小时

// Cloudflare Worker 验证地址
const AUTH_API_URL = 'https://91jianke.jxdnwl.workers.dev';

// 设置登录 cookie
export function setAuthCookie(userData: { username: string; displayName: string; role: string }) {
  const value = encodeURIComponent(JSON.stringify(userData));
  document.cookie = `${COOKIE_NAME}=${value}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

// 获取登录信息
export function getAuthData(): { username: string; displayName: string; role: string } | null {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === COOKIE_NAME) {
      try {
        return JSON.parse(decodeURIComponent(value));
      } catch {
        return null;
      }
    }
  }
  return null;
}

// 清除登录信息
export function clearAuth() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
}

// 检查是否已登录
export function isAuthenticated(): boolean {
  return getAuthData() !== null;
}

// Cloudflare Worker 验证
export async function verifyWithWorker(username: string, password: string) {
  try {
    const response = await fetch(AUTH_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    const data = await response.json();
    return data;
  } catch (e) {
    return { success: false, error: '验证服务不可用' };
  }
}
